import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { QUERY_KEYS } from 'src/constants'
import { commonService } from 'src/services'
import { IPublicProductsResponse } from 'src/types'

export const useGetPublicProducts = (
  params: { page?: number; pageSize?: number; search?: string, sortBy?: string, sortOrder?: 'DESC' | "ASC" } = {},
  options?: UseQueryOptions<IPublicProductsResponse>,
) => {
  return useQuery(
    [QUERY_KEYS.GET_PUBLIC_PRODUCTS, params],
    () => commonService.getPublicProducts(params),
    {
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000, // 5 minutes
      ...options,
    },
  )
}
